import { Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { useState, type CSSProperties } from "react";

import { Button } from "#/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverDescription,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger,
} from "#/components/ui/popover";
import { cn } from "#/lib/utils";

function PremiumUpgradePopoverActions({ onClose }: { onClose: () => void }) {
  return (
    <div className="flex gap-2">
      <Button
        size="sm"
        variant="premium"
        className="flex-1"
        render={<Link to="/premium" preload={false} />}
        nativeButton={false}
      >
        Upgrade
      </Button>
      <Button size="sm" variant="outline" className="flex-1" onClick={onClose}>
        Close
      </Button>
    </div>
  );
}

export function PremiumUpgradePopover({
  triggerLabel,
  description,
  className,
  style,
}: {
  triggerLabel: string;
  description: string;
  className?: string;
  style?: CSSProperties;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        render={
          <Button
            size="lg"
            className={cn("opacity-50", className)}
            style={style}
            aria-disabled="true"
            aria-label={`${triggerLabel} (premium required)`}
          />
        }
        nativeButton={false}
      >
        <Lock aria-hidden />
        {triggerLabel}
      </PopoverTrigger>
      <PopoverContent side="top" sideOffset={8} className="w-72 gap-3 p-3">
        <PopoverHeader>
          <PopoverTitle>Upgrade required</PopoverTitle>
          <PopoverDescription>{description}</PopoverDescription>
        </PopoverHeader>
        <PremiumUpgradePopoverActions onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
}
